var productionMode = false;
const urlStart = 'https://smpm-transporter-dash.qtrust.id';

export default {productionMode , urlStart};
